import React from 'react'
import { useSocketContext } from '../SocketProvider.hooks'
import { useToast } from '../../../components/Toast'

export const LinesheetDocumetAlert = () => {
    const { addToast } = useToast();
    const { socket } = useSocketContext();
  
    React.useEffect(() => {
      if (!socket) return;
  
      socket.on("NEW_EVENT_ADDED", (data: any) => {
        console.log("NEW_EVENT_ADDED", data);
        addToast({
            message: `You have ${data.name} Event at ${data.event_date.split("T")[0]}`,
            duration: 5000, // 5 seconds
        });
      });
    }, [socket, addToast]);
 
    return <></>
}
